import { Progress as KoProgressCircle } from 'antd';

export default KoProgressCircle;